<template>
  <div>
    <loading :active.sync="isloading" :is-full-page="true" color="green"></loading>
    
    <v-toolbar flat color="white" class="pt-3">
      <v-tabs slider-color="primary">
        <!-- <v-tab
          @click="clearFilters=!clearFilters;summary=false;activeInternetPackages=false;archivedPackages=false;unregisteredPackages=false; packageCategories=true;packageTemplates=false"
        >Package Template Groups</v-tab> -->
        <!-- <v-tab
          @click="clearFilters=!clearFilters;summary=false;activeInternetPackages=false;archivedPackages=false;unregisteredPackages=false; packageCategories=false;packageTemplates=true"
        >Package Templates</v-tab> -->

        <v-tab
          @click="clearFilters=!clearFilters;summary=false;activeInternetPackages=true;archivedPackages=false;unregisteredPackages=false; packageCategories=false;packageTemplates=false"
        >
          Data Packages
          <v-chip
            small
            dark
            color="success"
            v-if="activepackagesisps.length>0"
          >{{activepackagesisps.length}}</v-chip>
        </v-tab>
        <v-btn round color="primary">
        <v-icon>get_app</v-icon><download-excel
          :data="activepackagesisps"
          :fields="exportFields"
          worksheet="export"
          :name="'PackagesIsps'+new Date().getTime()+'.xls'">
          Export to Excel
      </download-excel>
      </v-btn>
      </v-tabs>
    </v-toolbar>
    <v-toolbar flat color="white pt-2" v-if="activeInternetPackages||unregisteredPackages">
      <v-spacer></v-spacer>
      <v-flex xs6 sm3 md3>
        <v-autocomplete
          id="filterNetworkId"
          clearable
          v-on:keyup.enter="enterEvent"
          v-model="filterNetwork"
          :items="locationnetworks"
          hide-no-data
          flat
          color="primary"
          label="Network"
          item-text="name"
          item-value="id"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs6 sm3 md3>
        <v-autocomplete
          id="filterIspId"
          clearable
          v-on:keyup.enter="enterEvent"
          v-model="filterIsp"
          :items="customers"
          hide-no-data
          flat
          color="primary"
          label="ISP"
          item-text="name"
          item-value="id"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs6 sm3 md3>
        <v-autocomplete
          id="filterSpeedId"
          clearable
          v-on:keyup.enter="enterEvent"
          v-model="filterSpeed"
          :items="filterspeeds"
          hide-no-data
          flat
          color="primary"
          label="Filter by Download Speed (Mbps)"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs6 sm3 md3>
        <v-autocomplete
          id="filterPackageTypeId"
          clearable
          v-on:keyup.enter="enterEvent"
          v-model="filterPackageType"
          :items="packagetypes"
          hide-no-data
          flat
          color="primary"
          label="Package Type"
          item-text="name"
          item-value="id"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs6 sm3 md3>
        <v-btn id="applyFilterButtonId" flat class="primary" round @click="specifyTab">Apply Filter</v-btn>
      </v-flex>
      <!-- <v-btn @click="getOtherPackages()">Fix</v-btn> -->
    </v-toolbar>
    <!-- <v-toolbar flat color="white pt-2" v-if="activeInternetPackages||unregisteredPackages">
      <v-btn
        id="addPackageButtonId"
        color="primary"
        dark
        class="mb-2"
        v-if="activeInternetPackages&&unregisteredPackages==false"
        @click="addItem()"
        round
      >Add Package</v-btn>
      <v-btn
        id="verifySelectedButtonId"
        v-if="activeInternetPackages&&selected.length>0 && unregisteredPackages==false"
        color="primary"
        dark
        class="mb-2"
        @click="bulkVerify()"
        round
      >Verify Selected</v-btn>
      <v-btn
        v-if="activeInternetPackages&&selected.length>0 && unregisteredPackages==false"
        color="primary"
        dark
        class="mb-2"
        @click="bulkShow()"
        round
      >Show Selected on Application Page</v-btn>
      <v-btn
        v-if="activeInternetPackages&&selected.length>0 && unregisteredPackages==false"
        color="primary"
        dark
        class="mb-2"
        @click="bulkHide()"
        round
      >Hide Selected on Application Page</v-btn>
      <v-btn
        id="deleteSelectedButtonId"
        v-if="activeInternetPackages&&selected.length>0 && unregisteredPackages==false"
        color="primary"
        dark
        class="mb-2"
        @click="bulkDelete()"
        round
      >Delete Selected</v-btn>
    </v-toolbar> -->
    <!-- Package Summary Table -->
    <v-data-table
      v-show="summary"
      :headers="summaryHeaders"
      class="elevation-1"
      :search="search"
      :expand="expand"
      :pagination.sync="pagination"
      :loading="loading"
      :items="activepackagesisps"
      item-key="id"
      align-center
    >
      <template v-slot:items="props">
        <!-- FNO -->
        <!-- <td class="text-xs-center">{{props.item.packagesFnoId}}</td> -->
        <td class="text-xs-center">{{props.item.customerOrganisation.name}}</td>
        <td class="text-xs-center">{{props.item.locationNetwork.name}}</td>
        <td class="text-xs-center">{{props.item.packagesFno.packagesFnoCat.packageCatType}}</td>
        <td class="text-xs-center">{{props.item.packagesFno.speedProfile.name}}</td>
        <td class="text-xs-center">{{props.item.name}}</td>
        <td class="text-xs-center">{{props.item.term}}</td>
        <td
          class="text-xs-center"
        >{{grossProfit(props.item.recurringPriceVatInc,props.item.packagesFno.packageBasePrice) | currency}}</td>

        <!-- ISP -->
      </template>
      <!-- Custom Row count and Paging text -->
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      <!-- No data Dispalay -->
      <!-- <template v-slot:no-data>
        <v-alert :value="true" color="error" icon="warning">Sorry, nothing to display here :(</v-alert>
      </template>-->
    </v-data-table>

    <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    <!-- Peview Package Modal -->
    <v-dialog persistent v-model="previewPackageModal" max-width="250px">
      <v-toolbar flat class="primary">
        <h1 class="headline white--text">Preview Package Card</h1>
      </v-toolbar>

      <v-card flat color="white">
        <div v-if="previewPackageModal">
          <packagesispscards :cardsPerPage="1" :packagesIsps="packagePreviewCard"></packagesispscards>
        </div>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn color="primary" round @click="previewPackageModal=false">Cancel</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    <v-data-table
      v-show="activeInternetPackages"
      v-model="selected"
      :headers="headers"
      class="elevation-1"
      :search="search"
      :expand="expand"
      :loading="isloading"
      disable-initial-sort
      :items="activepackagesisps"
      item-key="id"
      align-center
      :rows-per-page-items="[25, 50, 100, 250]"
    >
      <template v-slot:items="props">
        <!-- <td>
          <v-checkbox id="checkBoxId" v-model="props.selected" primary hide-details></v-checkbox>
        </td> -->
        <td class="justify-center layout px-0 py-3">
          <v-layout justify-center>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" medium @click="previewPackage(props.item)">remove_red_eye</v-icon>
            </template>
            <span>Preview Package Card</span>
          </v-tooltip>
          </v-layout>
          
        </td>
        <td class="text-xs-center">
          <v-icon
            v-if="!props.item.isVerified"
            color="red"
            medium
          >cancel</v-icon>
          <v-icon v-else color="tick" medium>check_circle_outline</v-icon>
        </td>
        <td class="text-xs-center">
          <v-icon
            v-if="props.item.isActive&&props.item.isVerified"
            medium
            color="tick"
          >check_circle_outline</v-icon>

          <v-tooltip top v-else-if="props.item.isActive&&!props.item.isVerified">
            <template v-slot:activator="{ on }">
              <v-icon
                class="ml-4"
                v-on="on"
                medium
                color="orange"
              >error_outlined</v-icon>
            </template>
            <span>Verification Required</span>
          </v-tooltip>
          <v-icon v-else medium color="red">cancel</v-icon>
        </td>

        <!-- FNO -->
        <!-- <td class="text-xs-center">{{props.item.packagesFnoId}}</td> -->
        <td class="text-xs-center">{{props.item.locationNetwork.name}}</td>
        <td class="text-xs-center">{{props.item.packagesFno.packagesFnoCat.packageCatType}}</td>
        <td
          class="text-xs-center"
          v-if="props.item.packagesIspTemplateId!==null"
        >{{props.item.packagesIspTemplate.name}}</td>
        <td class="text-xs-center" v-else></td>
        <td class="text-xs-center">{{props.item.packagesFno.speedProfile.name}}</td>
        <td
          class="text-xs-center"
          v-if="props.item.locationNetwork.lineRentalIncluded===true"
        >{{(props.item.packagesFno.packageBasePrice-props.item.locationNetwork.residentialLineRentalValue) | currency}}</td>
        <td class="text-xs-center" v-else>{{props.item.packagesFno.packageBasePrice | currency}}</td>

        <!-- ISP -->
        <td class="text-xs-center">{{props.item.customerOrganisation.name}}</td>
        <td class="text-xs-center">{{props.item.name}}</td>
        <td class="truncate">{{props.item.description}}</td>
        <td class="text-xs-center">{{props.item.onceOffPriceVatInc | currency}}</td>
        <td class="text-xs-center">{{props.item.recurringPriceVatInc | currency}}</td>
        <td
          class="text-xs-center"
          v-if="props.item.locationNetwork.lineRentalIncluded===true"
        >{{grossProfit(props.item.recurringPriceVatInc,props.item.packagesFno.packageBasePrice-props.item.locationNetwork.residentialLineRentalValue)| currency}}</td>
        <td
          class="text-xs-center"
          v-else
        >{{grossProfit(props.item.recurringPriceVatInc,props.item.packagesFno.packageBasePrice)| currency}}</td>
        <!-- isPromo -->
        <td class="text-xs-center" v-if="props.item.isPromotion">
          <v-icon color="green">done</v-icon>
        </td>
        <td class="text-xs-center" v-else>
          <v-icon color="red">not_interested</v-icon>
        </td>

        <td class="text-xs-center">{{props.item.promotionDescription}}</td>
        <td class="text-xs-center">{{props.item.term}}</td>
        <!-- isCapped -->
        <td class="text-xs-center" v-if="props.item.isCapped">
          <v-icon color="green">done</v-icon>
        </td>
        <td class="text-xs-center" v-else>
          <v-icon color="red">not_interested</v-icon>
        </td>

        <td class="text-xs-center">{{props.item.cappedAmountGb}}</td>
        <td class="text-xs-center" v-if="props.item.isShaped">
          <v-icon color="green">done</v-icon>
        </td>
        <td class="text-xs-center" v-else>
          <v-icon color="red">not_interested</v-icon>
        </td>
        <!-- isFup -->
        <td class="text-xs-center" v-if="props.item.isFup">
          <v-icon color="green">done</v-icon>
        </td>
        <td class="text-xs-center" v-else>
          <v-icon color="red">not_interested</v-icon>
        </td>

        <td class="text-xs-center">{{formatDate(props.item.startDate)}}</td>
        <td class="text-xs-center">{{formatDate(props.item.endDate)}}</td>

        <!-- isActive -->

        <td
          class="text-xs-center"
          v-if="props.item.createdById!==null"
        >{{props.item.createdBy.name+' '+props.item.createdBy.surname}}</td>
        <td class="text-xs-center" v-else></td>
        <td
          class="text-xs-center"
          v-if="props.item.lastModifiedById!==null"
        >{{props.item.lastModifiedBy.name+' '+props.item.lastModifiedBy.surname}}</td>
        <td class="text-xs-center" v-else></td>
        <td
          class="text-xs-center"
          v-if="props.item.verifiedById!==null"
        >{{props.item.verifiedBy.name+' '+props.item.verifiedBy.surname}}</td>
        <td class="text-xs-center" v-else></td>
      </template>
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>
   
    <!-- Unregistered Packages ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

    <v-data-table
      v-show="unregisteredPackages"
      calculate-widths
      :headers="headersUnregistered"
      class="elevation-1"
      :search="search"
      :expand="expand"
      :pagination.sync="pagination3"
      :loading="isloading"
      :items="unregisteredpackagesisps"
      item-key="id"
      align-center
      :rows-per-page-items="[10, 25, 50, 100]"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{props.item.locationNetwork.name}}</td>
        <td class="text-xs-center">{{props.item.packagesFno.packagesFnoCat.packageCatType}}</td>
        <td class="text-xs-center">{{props.item.packagesFno.packagesFnoCat.name}}</td>
        <td class="text-xs-center">{{props.item.packagesFno.speedProfile.name}}</td>
        <td
          class="text-xs-center"
          v-if="props.item.locationNetwork.lineRentalIncluded===true"
        >{{(props.item.packagesFno.packageBasePrice-props.item.locationNetwork.residentialLineRentalValue) | currency}}</td>
        <td class="text-xs-center" v-else>{{props.item.packagesFno.packageBasePrice | currency}}</td>
        <td class="text-xs-center">{{props.item.customerOrganisation.name}}</td>
      </template>
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>

  </div>
</template>

<script>
import Api from "@/services/Api";
import format from "date-fns/format";
import VueCurrencyFilter from "vue-currency-filter";
import dateformat from "dateformat";
import Loading from "vue-loading-overlay";
import PackagesIspsCards from "@/components/PackagesIspsCards.vue";
// import VueFroala from 'vue-froala-wysiwyg';

export default {
  props: [
    "locationnetworks",
    "packagesisps",
    "activepackagesisps",
    "archivedpackagesisps",
    "unregisteredpackagesisps",
    "packagesFno",
    "packagesIsp",
    "speedprofiles",
    "packagetypes",
    "isloading",
    "packagesispcats",
    "packagesisptemplates",
    "filterspeeds",
    "customerid",
    "organisations"
  ],
  components: {
    "vue-currency-filter": VueCurrencyFilter,
    loading: Loading,
    packagesispscards: PackagesIspsCards
    // froala: VueFroala
  },

  data() {
    return {
      packageTerms: ["month-to-month", "6 month", "12 month", "24 month"],
      date: new Date().toISOString().substr(0, 10),
      previewPackageModal: false,
      clearFilters: false,
      addPackageGroup: false,
      packageTemplateGroupInfo: false,
      packageTemplateGroupAttachedPackages: false,
      packagesIspTemplatesLocationNetwork: [],
      packageTemplates: true,
      viewPackageTemplateModal: false,
      packageTemplateGroupAttachedNetworks: false,
      packagesLocationNetworkArray: [],
      viewLocationNetworkModal: false,
      selectedNetworks: [],
      locationNetworkSearch: "",
      packagesIspCatLocationNetworkArray: [],
      packagesIspTemplateAttachedPackages: [],
      packageTemplateInfo: false,
      packageTemplateAttachedPackages: false,
      textEditor: "",
      textEditorConfig: {
        placeholderText: "Enter your package description",
        charCounterCount: true
      },
      packagesIspTemplateObj: {
        id: null,
        name: "",
        description: "",
        isCapped: false,
        isFup: false,
        isPromo: false,
        isShaped: false,
        recurringPrice: 0,
        onceOffPrice: 0
      },
      addPackageTemplate: false,
      editPackageTemplate: false,
      packageCategories: false,
      packagePreviewCard: [],
      packagesisptemplatesArray: [],
      selectablePackagesIspTemplates: [],
      packagesIspCatPackagesIspTemplatesArray: [],
      editPackageGroup: false,
      speedProfileTemplates: [],
      filterNetwork: null,
      filterIsp: null,
      filterSpeed: null,
      filterPackageType: null,
      filterCategory: null,
      filterUnregisteredPackages: false,
      filterArchivedPackages: false,
      filterActivePackages: false,
      selected: [],
      selectedTemplates: [],
      loadingPackages: this.isloading,
      menu: false,
      modal: false,
      isLoading: false,
      menu2: false,
      summary: false,
      basicInformation: false,
      basicInfo: false,
      activeInternetPackages: true,
      archivedPackages: false,
      unregisteredPackages: false,
      registerDialogToolbar: false,
      registerDialog: false,
      pricingTerm: false,
      packageSummary: false,
      showDetails: true,
      loading: false,
      expand: false,
      search: "",
      dialog: false,
      newDialog: false,
      editDialog: false,
      pagination: {},
      pagination1: {},
      pagination2: {},
      pagination3: {},
      speedErrorMessage: false,
      layer3ContentionRatios: [
        "1:1",
        "1:2",
        "1:4",
        "1:10",
        "1:20",
        "1:50",
        "1:100",
        "1:150"
      ],
      headersUnregistered: [
        // {
        //   text: "Action",
        //   align: "center",
        //   sortable: false
        // },
        {
          text: "Network",
          align: "center",
          value: "locationNetwork.name"
        },
        {
          text: "Package Type",
          align: "center",
          value: "packagesFno.packagesFnoCat.packageCatType"
        },
        {
          text: "Package Category",
          align: "center",
          value: "packagesFno.packagesFnoCat.name"
        },
        {
          text: "Speed Profile",
          align: "center",
          value: "packagesFno.speedProfile.downloadMbps"
        },
        {
          text: "FNO Price ex Vat",
          align: "center",
          value: "packagesFno.packageBasePrice"
        },
        {
          text: "Internet Service Provider",
          align: "center",
          value: "organisation.name"
        }
      ],
      packagesIspTemplateAttachedPackagesHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Verified",
          align: "center",
          value: "isVerified"
        },
        {
          text: "Visible on Application",
          align: "center",
          value: "isActive"
        },
        {
          text: "Network",
          align: "center",
          value: "locationNetwork.name"
        },
        // {
        //   text: "FNO Package",
        //   align: "center",
        //   value: "packagesFnoId"
        // },
        {
          text: "FNO Price ex Vat",
          align: "center",
          value: "packageBasePrice"
        },
        // {
        //   text: "ISPId",
        //   align: "center",
        //   value: "customerId"
        // },
        {
          text: "ISP NRC inc VAT",
          align: "centre",
          value: "recurringPriceVatInc"
        },
        {
          text: "ISP MRC inc VAT",
          align: "center",
          value: "onceOffPriceVatInc"
        },
        {
          text: "ISP Gross Profit",
          align: "center",
          sortable: false
        },
        {
          text: "Term",
          align: "center",
          value: "term"
        }
      ],
      locationNetworkHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Status",
          align: "center",
          value: "networkStatus"
        },
        {
          text: "Network Name",
          align: "center",
          value: "name"
        }
      ],
      locationNetworkHeadersReduced: [
        {
          text: "Status",
          align: "center",
          value: "networkStatus"
        },
        {
          text: "Network Name",
          align: "center",
          value: "name"
        }
      ],
      packagesisptemplatesHeadersReduced: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Speed Profile",
          align: "center",
          value: "speedProfile.name"
        },
        {
          text: "Template Name",
          align: "center",
          value: "name"
        },
        {
          text: "Recurring Price incl. VAT",
          align: "center",
          value: "recurringPrice"
        },
        {
          text: "Once Off Price incl. VAT",
          align: "center",
          value: "onceOffPrice"
        },
        {
          text: "FUP",
          align: "center",
          value: "isFup"
        },
        {
          text: "Shaped",
          align: "center",
          value: "isShaped"
        },
        {
          text: "Capped",
          align: "center",
          value: "isCapped"
        },
        {
          text: "Term",
          align: "center",
          value: "term"
        }
      ],
      packagesisptemplatesHeadersReducedModal: [
        {
          text: "Speed Profile",
          align: "center",
          value: "speedProfile.name"
        },
        {
          text: "Template Name",
          align: "center",
          value: "name"
        },
        {
          text: "Recurring Price incl. VAT",
          align: "center",
          value: "recurringPrice"
        },
        {
          text: "Once Off Price incl. VAT",
          align: "center",
          value: "onceOffPrice"
        },
        {
          text: "FUP",
          align: "center",
          value: "isFup"
        },
        {
          text: "Shaped",
          align: "center",
          value: "isShaped"
        },
        {
          text: "Capped",
          align: "center",
          value: "isCapped"
        },
        {
          text: "Term",
          align: "center",
          value: "term"
        }
      ],
      packagesisptemplatesHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Customer",
          align: "center",
          value: "customer.name"
        },
        {
          text: "Speed Profile",
          align: "center",
          value: "speedProfile.name"
        },
        {
          text: "Template Name",
          align: "center",
          value: "name"
        },
        {
          text: "Description",
          align: "center",
          value: "description"
        },
        {
          text: "Recurring Price incl. VAT",
          align: "center",
          value: "recurringPrice"
        },
        {
          text: "Once Off Price incl. VAT",
          align: "center",
          value: "onceOffPrice"
        },
        {
          text: "FUP",
          align: "center",
          value: "isFup"
        },
        {
          text: "Shaped",
          align: "center",
          value: "isShaped"
        },
        {
          text: "Capped",
          align: "center",
          value: "isCapped"
        },
        {
          text: "Capped Amount (Gb)",
          align: "center",
          value: "cappedAmountGb"
        },
        {
          text: "Promotion",
          align: "center",
          value: "isPromo"
        },
        {
          text: "Promotion Description",
          align: "center",
          value: "promoDescription"
        },
        {
          text: "Term",
          align: "center",
          value: "term"
        }
      ],
      packagesispcatsHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Customer Name",
          align: "center",
          value: "customer.name"
        },
        {
          text: "Group Name",
          align: "center",
          value: "name"
        },
        {
          text: "Code",
          align: "center",
          value: "code"
        },
        {
          text: "Description",
          align: "center",
          value: "description"
        }
      ],
      headers: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Verified",
          align: "center",
          value: "isVerified"
        },
        {
          text: "Visible on Application",
          align: "center",
          value: "isActive"
        },
        {
          text: "Network",
          align: "center",
          value: "locationNetwork.name"
        },
        {
          text: "Package Type",
          align: "center",
          value: "packagesFno.packagesFnoCat.packageCatType"
        },
        {
          text: "Linked Package Template",
          align: "center",
          value: "packagesIspTemplate.name"
        },
        {
          text: "Speed Profile",
          align: "center",
          value: "packagesFno.speedProfile.downloadMbps"
        },
        {
          text: "FNO Price ex Vat",
          align: "center",
          value: "packageBasePrice"
        },
        {
          text: "Internet Service Provider",
          align: "center",
          value: "customer.name"
        },
        {
          text: "ISP Package",
          align: "center",
          value: "name"
        },
        {
          text: " ISP Package Description",
          align: "center",
          value: "description",
          sortable: false
        },
        {
          text: "ISP NRC inc VAT",
          align: "right",
          sortable: false
        },
        {
          text: "ISP MRC inc VAT",
          align: "center",
          sortable: false
        },
        {
          text: "ISP Gross Profit",
          align: "center",
          sortable: false
        },
        {
          text: "Promotion",
          align: "center",
          value: "isPromotion"
        },
        {
          text: "Promo Description",
          align: "center",
          value: "promotionDescription",
          sortable: false
        },
        {
          text: "Term",
          align: "center",
          value: "term"
        },
        {
          text: "Capped",
          align: "center",
          value: "isCapped"
        },
        {
          text: "Capped Amount (Gb)",
          align: "center",
          value: "cappedAmountGb"
        },
        {
          text: "Shaped",
          align: "center",
          value: "isShaped"
        },
        {
          text: "Fair Usage Policy",
          align: "center",
          value: "isFup"
        },
        {
          text: "Start Date",
          align: "center",
          value: "startDate"
        },
        {
          text: "End Date",
          align: "center",
          value: "endDate"
        },
        {
          text: "Created",
          align: "center",
          value: "createdBy.name"
        },
        {
          text: "Last Modified",
          align: "center",
          value: "lastModifiedBy.name"
        },
        {
          text: "Verified By",
          align: "center",
          value: "verifiedBy.name"
        }
      ],
      summaryHeaders: [
        {
          text: "ISP",
          align: "center",
          value: "customer.name"
        },
        {
          text: "Network",
          align: "center",
          value: "locationNetwork.name"
        },
        {
          text: "Package Type",
          align: "center",
          value: "packagesFno.packageCatType.name"
        },
        {
          text: "Speed Profile",
          align: "center",
          value: "packagesFno.speedProfile.downloadMbps"
        },
        {
          text: "ISP Package",
          align: "center",
          value: "name"
        },
        {
          text: "Term",
          align: "center",
          value: "term",
          sortable: false
        },
        {
          text: "Recurring Gross Profit/Loss",
          align: "center",
          sortable: false
        }
      ],
       exportFields: {
        "id": "id",
        "name": "name",
        "description": "description",
        "onceOffPriceVatInc": "onceOffPriceVatInc",
        "recurringPriceVatInc":  "recurringPriceVatInc", 
        "recommendedRecurringPrice": "recommendedRecurringPrice", 
        "isPromotion": "isPromotion", 
        "promotionDescription": "promotionDescription", 
        "layer3Contention": "layer3Contention", 
        "term": "term", 
        "isCapped": "isCapped",
        "cappedAmountGb": "cappedAmountGb",
        "isFup": "isFup",
        "fupUrl": "fupUrl",
        "isShaped": "isShaped", 
        "startDate": "startDate", 
        "endDate": "endDate", 
        "packagesFno": "packagesFno.packageCode", 
        "isRegistered": "isRegistered", 
        "isVerified": "isVerified",              
        "customer": {
          callback: value => {
              return (
                value.customerOrganisation.name
              )
        }
        },
        "locationNetwork": {
          callback: value => {
            if (value.locationNetworkId !== null) {
              return (
                value.locationNetwork.name
              )
          }
        }
        },
        "locationNode": {
          callback: value => {
            if (value.locationNetworkId !== null) {
              return (
                value.locationNetwork.locationNode.name
              )
          }
        }
        },
         "createdBy": {
          callback: value => {
            if (value.createdById !== null) {
              return (
                value.createdBy.name +' '+ value.createdBy.surname
              )
          }
        }
        },
        "verifiedBy": {
          callback: value => {
            if (value.verifiedById !== null) {
              return (
                value.verifiedBy.name +' '+ value.verifiedBy.surname
              )
          }
        }
        },
         "lastModifiedBy": {
          callback: value => {
            if (value.lastModifiedById !== null) {
              return (
                value.lastModifiedBy.name +' '+ value.lastModifiedBy.surname
              )
          }
        }
        },
        "packagesIspTemplate": {
          callback: value => {
            if (value.packagesIspTemplateId !== null) {
              return (
                value.packagesIspTemplate.name
              )
          }
        }
        },
          "customerOrganisation": {
          callback: value => {
            if (value.customerOrganisationId !== null) {
              return (
                value.customerOrganisation.name
              )
          }
        }
        },
        "isDeleted": "isDeleted", 
        "isActive": "isActive", 
        "createdAt":"createdAt", 
        "updatedAt":"updatedAt", 
      },
      activePackagesIsps: [],
      archivedPackagesIsps: [],
      unregisteredPackagesIsps: [],
      packagesFnoById: [],
      customers: [],
      selectedLocationNetwork: [],
      packagesFnos: [],
      locationNetworks: [],
      locationPackages: [],
      locationPackagesId: [],

      packagesIspCatObj: {},
      editedIndex: -1,
      editedItem: {
        name: "",
        description: "",
        locationNetwork: "",
        locationNetworkId: "",
        onceOffPriceVatInc: "",
        recurringPriceVatInc: "",
        layer3Contention: "",
        isPromotion: "",
        term: "",
        fupUrl: "",
        isShaped: false,
        isCapped: "",
        cappedAmountGb: 0,
        isFup: false,
        startDate: "",
        endDate: "",
        packagesFnoId: "",
        packagesFno: "",
        packageCode: "",
        promotionDescription: "",
        customerId: "",
        customer: "",
        isVerified: null,
        createdById: null,
        lastModifiedById: null,
        verifiedById: null,
        attachPackageToTemplate: false,
        packagesIspTemplate: null,
        isActive: true,
        isDeleted: false
      },
      defaultItem: {
        name: "",
        description: "",
        locationNetwork: "",
        locationNetworkId: "",
        onceOffPriceVatInc: "",
        recurringPriceVatInc: "",
        layer3Contention: "",
        isPromotion: "",
        term: "",
        fupUrl: "",
        isShaped: false,
        isCapped: "",
        cappedAmountGb: 0,
        isFup: false,
        startDate: "",
        endDate: "",
        packagesFnoId: "",
        packagesFno: {
          name: '',
          speedProfile:{
            name: '',
            contentionRatio: ''
          }
        },
        packageCode: "",
        promotionDescription: "",
        customerId: "",
        customer: "",
        isVerified: null,
        createdById: null,
        lastModifiedById: null,
        verifiedById: null,
        attachPackageToTemplate: false,
        packagesIspTemplate: {
          name: '',
          speedProfile: {
            name: '',
            contentionRatio: ''
          }
        },
        isActive: true,
        isDeleted: false
      }
    };
  },
  // /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  watch: {
    "editedItem.packagesIspTemplate": {
      immediate: true,
      handler(value) {
        try {
          
          if (value.name !== "") {
          let speedProfileId = value.speedProfileId;
          let packagesFnoById = this.locationPackages.filter(function(el) {
            return el.speedProfileId === speedProfileId && el.isActive === true;
          });
          if(packagesFnoById.length>0){
            this.packagesFnoById = packagesFnoById[0];
            this.speedErrorMessage=false
          } else {
            this.speedErrorMessage=true
          }
          
        } 
        if(typeof value ==='undefined'){
          this.editedItem.packagesIspTemplate=this.defaultItem.packagesIspTemplate
        }
        } catch {
          
        }
      }
    },
    filterUnregisteredPackages(value) {
      const route = {
        name: this.$route.name
      };
      if (value === true) {
        route.query = {
          currentTab: "unregisteredPackages",
          locationNetworkId: this.filterNetwork,
          customerId: this.filterIsp,
          speedProfileId: this.filterSpeed,
          packageType: this.filterPackageType
        };
        this.$router.push(route);
        this.filterUnregisteredPackages = false;
      }
    },
    filterArchivedPackages(value) {
      const route = {
        name: this.$route.name
      };
      if (value === true) {
        route.query = {
          currentTab: "archivedPackages",
          locationNetworkId: this.filterNetwork,
          customerId: this.filterIsp,
          speedProfileId: this.filterSpeed,
          packageType: this.filterPackageType
        };
        this.$router.push(route);
        this.filterArchivedPackages = false;
      }
    },
    filterActivePackages(value) {
      const route = {
        name: this.$route.name
      };
      if (value === true) {
        route.query = {
          currentTab: "activePackages",
          locationNetworkId: this.filterNetwork,
          customerId: this.filterIsp,
          speedProfileId: this.filterSpeed,
          packageType: this.filterPackageType
        };
        this.$router.push(route);
        this.filterActivePackages = false;
      }
    }
  },

  created() {
    this.initialize();
  },
  // /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  methods: {
    async getOtherPackages(){
      let ispLocationNetworks=[]
      let packages =[]
      await Api()
      .get('/supplier/ispLocationNetwork')
      .then(async response=>{
        ispLocationNetworks = response.data})
      await Api()
      .get('/supplier/packagesIsps/showAll')
      .then(async response=>{
        packages = response.data
      })
      for (let i=0; i< packages.length;i++){
        let customerOrganisationId = packages[i].customerOrganisationId
        let locationNetworkId = packages[i].locationNetworkId
        let fnoPackageId = packages[i].packagesFnoId
        let ispLocationNetwork = await ispLocationNetworks.filter(function(el){
          return el.customerOrganisationId ===customerOrganisationId&&
                  el.locationNetworkId === locationNetworkId&&
                  el.packagesFnoId === fnoPackageId&&
                  el.isActive === true&&
                  el.isDeleted === false
        })
        if(ispLocationNetwork.length>0){
          console.log(ispLocationNetwork[0])
          console.log(packages[i].id)
          await Api()
          .put('/customer/packagesIsps/'+packages[i].id,{
            ispLocationNetworkId: ispLocationNetwork[0].id
          }).then(response=>{
            console.log(response.data)
          })
        } else {
          await Api()
          .put('/customer/packagesIsps/'+packages[i].id,{
            ispLocationNetworkId: null
          }).then(response=>{
            console.log(response.data)
          })
        }
      }
    },
    async migratePackages(){
      let ispLocationNetworks=[]
      await Api()
      .get('/supplier/ispLocationNetwork')
      .then(async response=>{
        console.log(response.data)
        ispLocationNetworks = response.data})
      await Api()
      .get('/supplier/packagesIsps/showAll')
      .then(async response=>{
        console.log(response.data)
        let packages = await response.data.filter(function(el){
          return el.isRegistered===true
        })
        for (let a=0; a< packages.length;a++){
          if(packages[a].customerId!==null){
            await Api()
        .put('/customer/packagesIsps/'+packages[a].id,{
          customerOrganisationId: packages[a].customer.customerOrganisationId
        })
        packages[a].customerOrganisationId=packages[a].customer.customerOrganisationId
        let networkId = packages[a].locationNetworkId
           let fnoPackageId = packages[a].packagesFnoId
           let customerOrganisationId = packages[a].customerOrganisationId
          let ispLocationNetworkId = await ispLocationNetworks.filter(function(el){
            return el.locationNetworkId ===networkId&&
                  el.customerOrganisationId ===customerOrganisationId&&
            el.packagesFnoId===fnoPackageId
          })
          if(ispLocationNetworkId.length>0){
            let postId = ispLocationNetworkId[0].id
            await Api()
          .put('/customer/packagesIsps/'+this.activepackagesisps[a].id,{
            ispLocationNetworkId: postId
          })
          }
        }}
      })
    },
    async previewPackage(item) {
      this.packagePreviewCard = [];
      await this.packagePreviewCard.push(item);
      this.previewPackageModal = true;
    },
    async bulkAddTemplatesToGroup() {
      let existingPackageTemplates = [];
      let newPackageTemplates = [];
      if (this.packagesisptemplatesArray.length > 0) {
        for (let x = 0; x < this.packagesisptemplatesArray.length; x++) {
          if (this.packagesisptemplatesArray[x].isActive) {
            await existingPackageTemplates.push(
              this.packagesisptemplatesArray[x].id
            );
          }
        }
      }

      for (let a = 0; a < this.selectedTemplates.length; a++) {
        if (!existingPackageTemplates.includes(this.selectedTemplates[a].id)) {
          await Api()
            .post("/packagesIspCatPackagesIspTemplate", {
              packagesIspCatId: this.packagesIspCatObj.id,
              packagesIspTemplateId: this.selectedTemplates[a].id,
              isActive: true,
              isDeleted: false
            })
            .then(response => {
              this.packagesisptemplatesArray.push(this.selectedTemplates[a]);
            });
        }
      }
      this.$emit("groupTemplateChange");
    },
    async bulkAddNetworksToGroup() {
      let existingNetworks = [];
      if (this.packageTemplateLocationNetworks.length > 0) {
        for (let x = 0; x < this.packageTemplateLocationNetworks.length; x++) {
          if (this.packageTemplateLocationNetworks[x].isActive) {
            await existingNetworks.push(
              this.packageTemplateLocationNetworks[x].id
            );
          }
        }
      }

      for (let a = 0; a < this.selectedNetworks.length; a++) {
        if (!existingNetworks.includes(this.selectedNetworks[a].id)) {
          await Api()
            .post("/packagesIspCatLocationNetwork", {
              packagesIspCatId: this.packagesIspCatObj.id,
              locationNetworkId: this.selectedNetworks[a].id,
              isActive: true,
              isDeleted: false
            })
            .then(async response => {
              await this.packageTemplateLocationNetworks.push(
                this.selectedNetworks[a]
              );
            });
        }
      }
      this.$emit("groupTemplateChange");
    },
    updateIspPackages() {
      Api()
        .get("/packagesIsps")
        .then(response => {
          for (let i = 0; i < response.data.length; i++) {
            if (
              response.data[i].packagesFno.isActive === false ||
              response.data[i].packagesFno.isDeleted === true
            ) {
              Api().put("/packagesIsps/" + response.data[i].id, {
                isActive: false,
                isDeleted: true
              });
            }
          }
        });
    },
    removeTemplatePackageFromGroup(item) {
      let index = 0;
      let arrayIndex = this.packagesisptemplatesArray.indexOf(item);
      for (
        let i = 0;
        i < this.packagesIspCatPackagesIspTemplatesArray.length;
        i++
      ) {
        if (
          item ==
          this.packagesIspCatPackagesIspTemplatesArray[i].packagesIspTemplate
        ) {
          index = i;
        }
      }

      confirm("Are you sure you want to remove this package from the group?") &&
        Api()
          .put(
            "/packagesIspCatPackagesIspTemplate/" +
              this.packagesIspCatPackagesIspTemplatesArray[index].id,
            {
              isActive: false,
              isDeleted: true
            }
          )
          .then(async response => {
            await this.packagesisptemplatesArray.splice(arrayIndex, 1);
            this.$emit("groupTemplateChange");
          });
    },
    removePackageFromTemplate(item) {
      confirm(
        "Are you sure you want to unlink this package? WARNING: This will not delete the Data Package"
      ) &&
        Api()
          .put("/packagesIsps/" + item.id, {
            packagesIspTemplateId: null
          })
          .then(async response => {
            this.$emit("groupTemplateChange");
            this.$emit("packagesIspsSaved");
            this.initialize();
          });
    },
    removeNetworkFromGroup(item) {
      let index = 0;
      let arrayIndex = this.packageTemplateLocationNetworks.indexOf(item);
      for (let i = 0; i < this.packagesIspCatLocationNetworkArray.length; i++) {
        if (
          item == this.packagesIspCatLocationNetworkArray[i].locationNetwork
        ) {
          index = i;
        }
      }

      confirm("Are you sure you want to remove this network from the group?") &&
        Api()
          .put(
            "/packagesIspCatLocationNetwork/" +
              this.packagesIspCatLocationNetworkArray[index].id,
            {
              isActive: false,
              isDeleted: true
            }
          )
          .then(async response => {
            await this.packageTemplateLocationNetworks.splice(arrayIndex, 1);
            this.$emit("groupTemplateChange");
          });
    },
    enterEvent() {},
    specifyTab() {
      if (this.activeInternetPackages === true) {
        this.filterActivePackages = true;
      } else if (this.archivedPackages === true) {
        this.filterArchivedPackages = true;
      } else if (this.unregisteredPackages === true) {
        this.filterUnregisteredPackages = true;
      }
    },
    fetchPackagesIsps() {
      Api()
        .get("/packagesIsps/active")
        .then(response => {
          this.activePackagesIsps = response.data;
        });
      // Api()
      // .get("/packagesIsps/inactive")
      // .then(response => {
      //   this.archivedPackagesIsps = response.data;
      // });
      Api()
        .get("/packagesIsps/unregistered")
        .then(response => {
          this.unregisteredPackagesIsps = response.data;
        });
      // Api()
      // .get("/packagesIsps")
      // .then(response => {
      //   this.locationNetworks = response.data;
      // });
    },
    fetchCustomers() {
      Api()
        .get("/organisation/subOrganisations/ISP")
        .then(response => {
          this.customers = response.data;
        });
    },
    fetchPackagesFno() {
      Api()
        .get("/packagesFnos/basic/active")
        .then(response => {
          this.packagesFnos = response.data;
        });
    },
    fetchLocationNetworks() {
      Api()
        .get("/locationnetworks")
        .then(response => {
          this.locationNetworks = response.data;
        });
    },
    fetchSelectedNetwork(networkId) {
      Api()
        .get("/locationnetworks/" + networkId)
        .then(response => {
          this.selectedLocationNetwork = response.data[0];
        });
    },
    formatDate(date) {
      if (date == null) {
        return null;
      } else {
        return dateformat(date, "dd/mm/yyyy");
      }
    },
    getPackageDetails(packagesFnoId) {
      Api()
        .get("/packagesFnoLocationNetwork/showByFnoPackages/" + packagesFnoId)
        .then(response => {
          this.packagesFnoById = response.data[0].packagesFno;
        });
    },
    initialize() {
      //this.fetchPackagesIsps();
      this.fetchCustomers();
      this.fetchPackagesFno();
      //this.fetchLocationNetworks();
    },
    grossProfit(IspPrice, FnoPrice) {
      return parseFloat(IspPrice) - parseFloat(FnoPrice) * (1 + $VAT);
    },

    async getLocationPackages(networkId) {
      this.locationPackages = [];
            this.locationPackagesId = [];
            let speedProfileIdList = [];
            this.packagesIspTemplatesLocationNetwork = [];
      
    },
    async getSpeedProfileTemplates(speedProfileId) {
      let customerId = this.editedItem.customerId;
      this.speedProfileTemplates = await this.packagesisptemplates.filter(
        function(el) {
          return (
            el.customerId === customerId && el.speedProfileId === speedProfileId
          );
        }
      );
    },
    formattedDate: function(date) {
      return date ? format(date, "Do MMM YYYY") : "";
    },

    editItem(item) {
      if(this.authUpdate(this.$store.state.currentRoute)){
      this.editedIndex = this.activePackagesIsps.indexOf(item);
      this.editedItem = Object.assign({}, item);
       this.editDialog=true;
       this.basicInformation=true;
       this.pricingTerm=false;
       this.packageSummary=false;
       this.getPackageDetails(this.editedItem.packagesFnoId);
       this.fetchSelectedNetwork(this.editedItem.locationNetworkId); 
       this.getLocationPackages(this.editedItem.locationNetworkId)
      if (
        this.editedItem.layer3Contention === "" ||
        this.editedItem.layer3Contention === null
      ) {
        this.editedItem.layer3Contention =
          item.packagesFno.speedProfile.contentionRatio;
      }
      if (this.editedItem.packagesIspTemplateId !== null) {
        this.editedItem.attachPackageToTemplate = true;
      }

      if (this.editedItem.endDate !== null) {
        this.editedItem.endDate = new Date(this.editedItem.endDate)
          .toISOString()
          .substr(0, 10);
      }
      if (this.editedItem.startDate !== null) {
        this.editedItem.startDate = new Date(this.editedItem.startDate)
          .toISOString()
          .substr(0, 10);
      }
      this.editDialog = true;
      }
    },
    async editPackageGroupItem(item) {
      if(this.authUpdate(this.$store.state.currentRoute)){
      this.packagesIspCatObj = Object.assign({}, item);
      this.packagesisptemplatesArray = [];
      this.selectedTemplates = [];
      this.packagesIspCatPackagesIspTemplatesArray = [];
      this.packageTemplateLocationNetworks = [];
      this.packagesIspCatLocationNetworkArray = [];
      for (
        let i = 0;
        i < this.packagesIspCatObj.packagesIspCatPackagesIspTemplates.length;
        i++
      ) {
        if (
          this.packagesIspCatObj.packagesIspCatPackagesIspTemplates[i]
            .isActive &&
          !this.packagesIspCatObj.packagesIspCatPackagesIspTemplates[i]
            .isDeleted
        ) {
          if (
            this.packagesIspCatObj.packagesIspCatPackagesIspTemplates[i]
              .packagesIspTemplate.isActive &&
            !this.packagesIspCatObj.packagesIspCatPackagesIspTemplates[i]
              .packagesIspTemplate.isDeleted
          ) {
            this.packagesisptemplatesArray.push(
              this.packagesIspCatObj.packagesIspCatPackagesIspTemplates[i]
                .packagesIspTemplate
            );
            this.selectedTemplates.push(
              this.packagesIspCatObj.packagesIspCatPackagesIspTemplates[i]
                .packagesIspTemplate
            );
            this.packagesIspCatPackagesIspTemplatesArray.push(
              this.packagesIspCatObj.packagesIspCatPackagesIspTemplates[i]
            );
          }
        }
      }
      for (
        let i = 0;
        i < this.packagesIspCatObj.packagesIspCatLocationNetworks.length;
        i++
      ) {
        if (
          this.packagesIspCatObj.packagesIspCatLocationNetworks[i].isActive &&
          !this.packagesIspCatObj.packagesIspCatLocationNetworks[i].isDeleted
        ) {
          this.packageTemplateLocationNetworks.push(
            this.packagesIspCatObj.packagesIspCatLocationNetworks[i]
              .locationNetwork
          );
          this.selectedNetworks.push(
            this.packagesIspCatObj.packagesIspCatLocationNetworks[i]
              .locationNetwork
          );
          this.packagesIspCatLocationNetworkArray.push(
            this.packagesIspCatObj.packagesIspCatLocationNetworks[i]
          );
        }
      }

      let customerId = this.packagesIspCatObj.customerId;
      this.selectablePackagesIspTemplates = this.packagesisptemplates.filter(
        function(el) {
          return el.customerId === customerId;
        }
      );
      this.packageTemplateGroupInfo = true;
      this.packageTemplateGroupAttachedPackages = false;
      this.editPackageGroup = true;
      }
    },
    deletePackageTemplateItem(item) {
      if(this.authDelete(this.$store.state.currentRoute)){
      let packagesIspTemplateId = item.id;
      this.packagesIspTemplateAttachedPackages = this.activepackagesisps.filter(
        function(el) {
          return el.packagesIspTemplateId === packagesIspTemplateId;
        }
      );
      confirm(
        "Are you sure you would like to delete this Package Template? WARNING: This will delete all linked Data Packages"
      ) &&
        Api()
          .put("/packagesIspTemplate/" + item.id, {
            isActive: false,
            isDeleted: true
          })
          .then(response => {
            this.$emit("groupTemplateChange");
            this.editPackageTemplate = false;
          });
      for (
        let i = 0;
        i < this.packagesIspTemplateAttachedPackages.length;
        i++
      ) {
        Api().put(
          "customer/packagesIsps/" + this.packagesIspTemplateAttachedPackages[i].id,
          {
            isActive: false,
            isDeleted: true
          }
        );
      }
      this.initialize();
      this.$emit("packagesIspsSaved");
      }
    },
    editPackageTemplateItem(item) {
      if(this.authUpdate(this.$store.state.currentRoute)){
      this.packagesIspTemplateObj = Object.assign({}, item);

      let packagesIspTemplateId = this.packagesIspTemplateObj.id;
      this.packagesIspTemplateAttachedPackages = this.activepackagesisps.filter(
        function(el) {
          return el.packagesIspTemplateId === packagesIspTemplateId;
        }
      );
      }
    },
    registerItem(item) {
      if(this.authCreate(this.$store.state.currentRoute)){
      this.editedIndex = this.unregisteredPackagesIsps.indexOf(item);
      this.editedItem = Object.assign({}, item);
      if (
        this.editedItem.layer3Contention === "" ||
        this.editedItem.layer3Contention === null
      ) {
        this.editedItem.layer3Contention =
          item.packagesFno.speedProfile.contentionRatio;
      }
      if (this.editedItem.endDate !== null) {
        this.editedItem.endDate = new Date(this.editedItem.endDate)
          .toISOString()
          .substr(0, 10);
      }
      if (this.editedItem.startDate !== null) {
        this.editedItem.startDate = new Date(this.editedItem.startDate)
          .toISOString()
          .substr(0, 10);
      }
      (this.editedItem.packagesFnoId = item.packagesFnoId),
        (this.registerDialog = true);
      this.registerDialogToolbar = true;
      }
    },

    deleteItem(id) {
      if(this.authDelete(this.$store.state.currentRoute)){
      confirm("Are you sure you want to delete this item?") &&
        Api()
          .put("/customer/packagesIsps/" + id, {
            isActive: false,
            isDeleted: true
          })
          .then(response => {
            this.initialize();
            this.$emit("packagesIspsSaved");
          });
      }
    },
    clearFields() {
      this.editedItem = Object.assign({}, this.defaultItem);
      // this.editedItem={}
    },

    close() {
      this.dialog = false;
      this.newDialog = false;
      this.editDialog = false;
      this.registerDialogToolbar = false;
      this.registerDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    async verifyItem(item) {
      if(this.authUpdate(this.$store.state.currentRoute)){
      let isVerified = false;
      if (item.isVerified === null || item.isVerified === false) {
        isVerified = true;
      } else {
        isVerified = false;
      }
      confirm("Are you sure you would like to verify this package?") &&
        (await Api()
          .put("customer/packagesIsps/" + item.id, {
            isVerified: isVerified,
            verifiedById: this.$store.state.user.id
          })
          .then(response => {
            this.$emit("packagesIspsSaved");
            this.$emit("groupTemplateChange");
            if (typeof this.packagesIspTemplateObj !== "undefined") {
              this.editPackageTemplateItem(this.packagesIspTemplateObj);
            }
          }));
      }
    },
    bulkVerify() {
      if(this.authUpdate(this.$store.state.currentRoute)){
      let numberOfPackages = this.selected.length;
      let cf = confirm(
        "Are you sure you would like to verify " +
          numberOfPackages +
          " package(s)?"
      );
      if (cf == true) {
        this.loadingPackages = true;
        for (let i = 0; i < this.selected.length; i++) {
          Api().put("/customer/packagesIsps/" + this.selected[i].id, {
            isVerified: true,
            verifiedById: this.$store.state.user.id
          });
        }
        this.$emit("packagesIspsSaved");
        this.loadingPackages = false;
      }
      }
    },
    bulkDelete() {
      if(this.authDelete(this.$store.state.currentRoute)){
      let numberOfPackages = this.selected.length;
      this.loadingPackages = true;
      let cf = confirm(
        "Are you sure you would like to delete " +
          numberOfPackages +
          " package(s)?"
      );
      if (cf == true) {
        this.loadingPackages = true;

        for (let i = 0; i < this.selected.length; i++) {
          Api().put("/packagesIsps/" + this.selected[i].id, {
            isActive: false,
            isDeleted: true,
            lastModifiedById: this.$store.state.user.id
          });
        }
        this.$emit("packagesIspsSaved");
        this.loadingPackages = false;
      }
      }
    },
    bulkShow() {
      if(this.authUpdate(this.$store.state.currentRoute)){
      let numberOfPackages = this.selected.length;
      let cf = confirm(
        "Are you sure you would like to make " +
          numberOfPackages +
          " package(s) available on the Application Page?"
      );
      if (cf == true) {
        this.loadingPackages = true;
        for (let i = 0; i < this.selected.length; i++) {
          Api().put("/packagesIsps/" + this.selected[i].id, {
            isActive: true,
            lastModifiedById: this.$store.state.user.id
          });
        }
        this.$emit("packagesIspsSaved");
        this.loadingPackages = false;
      }
      }
    },
    bulkHide() {
      if(this.authUpdate(this.$store.state.currentRoute)){
      let numberOfPackages = this.selected.length;
      let cf = confirm(
        "Are you sure you would like to hide " +
          numberOfPackages +
          " package(s)?"
      );
      if (cf == true) {
        this.loadingPackages = true;
        for (let i = 0; i < this.selected.length; i++) {
          Api().put("/packagesIsps/" + this.selected[i].id, {
            isActive: false,
            lastModifiedById: this.$store.state.user.id
          });
        }
        this.$emit("packagesIspsSaved");
        this.loadingPackages = false;
      }
      }
    },
    async showHideItem(item) {
      if(this.authUpdate(this.$store.state.currentRoute)){
      confirm(
        "Are you sure you would like to change the visibility of this package?"
      ) &&
        (await Api()
          .put("/packagesIsps/" + item.id, {
            isActive: !item.isActive,
            lastModifiedById: this.$store.state.user.id
          })
          .then(async response => {
            await this.$emit("packagesIspsSaved");
            await this.$emit("groupTemplateChange");
            this.initialize();
            if (typeof this.packagesIspTemplateObj !== "undefined") {
              this.editPackageTemplateItem(this.packagesIspTemplateObj);
            }
          }));
      }
    },
    saveNewPackageTemplate() {
      if(this.authCreate(this.$store.state.currentRoute)){
      Api()
        .post("/packagesIspTemplate", {
          name: this.packagesIspTemplateObj.name,
          description: this.packagesIspTemplateObj.description,
          customerId: this.packagesIspTemplateObj.customerId,
          speedProfileId: this.packagesIspTemplateObj.speedProfileId,
          recurringPrice: this.packagesIspTemplateObj.recurringPrice,
          onceOffPrice: this.packagesIspTemplateObj.onceOffPrice,
          isFup: this.packagesIspTemplateObj.isFup,
          isShaped: this.packagesIspTemplateObj.isShaped,
          isPromo: this.packagesIspTemplateObj.isPromo,
          promoDescription: this.packagesIspTemplateObj.promoDescription,
          isCapped: this.packagesIspTemplateObj.isCapped,
          cappedAmountGb: this.packagesIspTemplateObj.cappedAmountGb,
          term: this.packagesIspTemplateObj.term,
          isActive: true,
          isDeleted: false
        })
        .then(response => {
          this.addPackageTemplate = false;
          this.$emit("groupTemplateChange");
        });
      }
    },
    addItem(){
      if(this.authCreate(this.$store.state.currentRoute)){
      this.newDialog=true;
      this.basicInformation=true;
      this.pricingTerm=false;
      this.packageSummary=false; 
      this.clearFields()
      }
    },
    savePackageTemplate() {
      if(this.authUpdate(this.$store.state.currentRoute)){
      confirm(
        "Are you sure you would like to update this Package Template? WARNING: This will update all linked Data Packages"
      ) &&
        Api()
          .put("/packagesIspTemplate/" + this.packagesIspTemplateObj.id, {
            name: this.packagesIspTemplateObj.name,
            description: this.packagesIspTemplateObj.description,
            customerId: this.packagesIspTemplateObj.customerId,
            speedProfileId: this.packagesIspTemplateObj.speedProfileId,
            recurringPrice: this.packagesIspTemplateObj.recurringPrice,
            onceOffPrice: this.packagesIspTemplateObj.onceOffPrice,
            isFup: this.packagesIspTemplateObj.isFup,
            isShaped: this.packagesIspTemplateObj.isShaped,
            isPromo: this.packagesIspTemplateObj.isPromo,
            promoDescription: this.packagesIspTemplateObj.promoDescription,
            isCapped: this.packagesIspTemplateObj.isCapped,
            cappedAmountGb: this.packagesIspTemplateObj.cappedAmountGb,
            // layer3Contention: this.packagesIspTemplateObj.layer3Contention,
            term: this.packagesIspTemplateObj.term,
            
            isActive: true,
            isDeleted: false
          })
          .then(response => {
            this.$emit("groupTemplateChange");
          });
      for (
        let i = 0;
        i < this.packagesIspTemplateAttachedPackages.length;
        i++
      ) {
        Api().put(
          "/packagesIsps/" + this.packagesIspTemplateAttachedPackages[i].id,
          {
            name: this.packagesIspTemplateObj.name,
            description: this.packagesIspTemplateObj.description,
            customerId: this.packagesIspTemplateObj.customerId,
            recurringPriceVatInc: this.packagesIspTemplateObj.recurringPrice,
            onceOffPriceVatInc: this.packagesIspTemplateObj.onceOffPrice,
            isFup: this.packagesIspTemplateObj.isFup,
            isShaped: this.packagesIspTemplateObj.isShaped,
            isPromotion: this.packagesIspTemplateObj.isPromo,
            promotionDescription: this.packagesIspTemplateObj.promoDescription,
            isCapped: this.packagesIspTemplateObj.isCapped,
            cappedAmountGb: this.packagesIspTemplateObj.cappedAmountGb,
            term: this.packagesIspTemplateObj.term,
            lastModifiedById: this.$store.state.user.id
          }
        );
      }
      this.$emit("packagesIspsSaved");
      this.initialize();
      this.editPackageTemplate = false;
      }
    },
    saveNewPackageGroup() {
      if(this.authCreate(this.$store.state.currentRoute)){

      Api()
        .post("/packagesIspCats", {
          customerId: this.packagesIspCatObj.customerId,
          name: this.packagesIspCatObj.name,
          code: this.packagesIspCatObj.code,
          description: this.packagesIspCatObj.description,
          packageCatType: this.packagesIspCatObj.packageCatType,
          isActive: true,
          isDeleted: false
        })
        .then(response => {
          this.addPackageGroup = false;
          this.$emit("groupTemplateChange");
        });
      }
    },
    savePackageGroup() {
      if(this.authUpdate(this.$store.state.currentRoute)){
      let proceed = false;

      confirm(
        "Are you sure you would like to save this Package Group? WARNING: This will attach all linked Data Packages to selected Networks"
      ) && (proceed = true);
      if (proceed) {
        let customerId = this.packagesIspCatObj.customerId;
        if (this.selectedNetworks.length > 0) {
          for (let i = 0; i < this.selectedNetworks.length; i++) {
            let currentPackageTemplates = [];
            let currentNetwork = this.selectedNetworks[i];
            let selectedPackageTemplates = [];
            let availableFnoPackages = [];
            let allIspPackageTemplates = [];
            // console.log(this.selectedNetworks[i])
            // if(typeof this.selectedNetworks[i].packagesIspCatLocationNetworks!=='undefined'){
            //   for(let d=0; d<this.selectedNetworks[i].packagesIspCatLocationNetworks.length;d++){
            //     console.log(this.selectedNetworks[i].packagesIspCatLocationNetworks[d])
            //     for(let e=0;e<this.selectedNetworks[i].packagesIspCatLocationNetworks[d].packageIspCat.packagesIspTemplates.length;e++){
            //       if(this.selectedNetworks[i].packagesIspCatLocationNetworks[d].packageIspCat.packagesIspTemplates[e].customerId===customerId&&
            //       this.selectedNetworks[i].packagesIspCatLocationNetworks[d].packageIspCat.packagesIspTemplates[e].isActive&&
            //       !this.selectedNetworks[i].packagesIspCatLocationNetworks[d].packageIspCat.packagesIspTemplates[e].isDeleted){
            //         console.log(this.selectedNetworks[i].packagesIspCatLocationNetworks[d].packageIspCat.packagesIspTemplates[e])
            //         allIspPackageTemplates.push(this.selectedNetworks[i].packagesIspCatLocationNetworks[d].packageIspCat.packagesIspTemplates[e])
            //       }
            //     }
            //   }
            // }
            if (
              typeof this.selectedNetworks[i].packagesFnoLocationNetworks !==
              "undefined"
            ) {
              for (
                let b = 0;
                b < this.selectedNetworks[i].packagesFnoLocationNetworks.length;
                b++
              ) {
                this.selectedNetworks[i].packagesFnoLocationNetworks[b];
                availableFnoPackages.push(
                  this.selectedNetworks[i].packagesFnoLocationNetworks[b]
                    .packagesFno
                );
              }
            }

            let currentPackages = this.activepackagesisps.filter(function(el) {
              return (
                el.customerId === customerId &&
                el.locationNetworkId === currentNetwork.id
              );
            });
            for (let y = 0; y < currentPackages.length; y++) {
              currentPackageTemplates.push(
                currentPackages[y].packagesIspTemplateId
              );
            }
            for (let x = 0; x < this.packagesisptemplatesArray.length; x++) {
              selectedPackageTemplates.push(this.packagesisptemplatesArray[x].id);
              if (!currentPackageTemplates.includes(this.packagesisptemplatesArray[x].id)
              ) {
                for (let c = 0; c < availableFnoPackages.length; c++) {
                  if (
                    this.packagesisptemplatesArray[x].speedProfileId ===
                    availableFnoPackages[c].speedProfileId
                  ) {
                    Api().post("/packagesIsps", {
                      name: this.packagesisptemplatesArray[x].name,
                      description: this.packagesisptemplatesArray[x]
                        .description,
                      onceOffPriceVatInc: this.packagesisptemplatesArray[x]
                        .onceOffPrice,
                      recurringPriceVatInc: this.packagesisptemplatesArray[x]
                        .recurringPrice,
                      isPromotion: this.packagesisptemplatesArray[x].isPromo,
                      promotionDescription: this.packagesisptemplatesArray[x]
                        .promoDescription,
                      term: this.packagesisptemplatesArray[x].term,
                      isCapped: this.packagesisptemplatesArray[x].isCapped,
                      isShaped: this.packagesisptemplatesArray[x].isShaped,
                      layer3Contention: this.packagesisptemplatesArray[x]
                        .layer3Contention,
                      cappedAmountGb: this.packagesisptemplatesArray[x]
                        .cappedAmountGb,
                      isFup: this.packagesisptemplatesArray[x].isFup,
                      startDate: new Date(),
                      endDate: null,
                      packagesFnoId: availableFnoPackages[c].id,
                      locationNetworkId: this.selectedNetworks[i].id,
                      customerId: this.packagesisptemplatesArray[x].customerId,
                      isVerified: false,
                      isRegistered: true,
                      createdById: this.$store.state.user.id,
                      lastModifiedById: this.$store.state.user.id,
                      verifiedById: null,
                      packagesIspTemplateId: this.packagesisptemplatesArray[x]
                        .id,
                      isActive: false
                    });
                  }
                }
              }
            }
            Api()
              .get(
                "/packagesIspCatLocationNetwork/byNetwork/" +
                  this.selectedNetworks[i].id
              )
              .then(async response => {
                let packagesIspCats = response.data;
                if(typeof response.data!=='undefined'){
                for (let f = 0; f < packagesIspCats.length; f++) {
                  if (
                    packagesIspCats[f].packagesIspCat.customerId === customerId
                  ) {
                    for (
                      let g = 0;
                      g <
                      packagesIspCats[f].packagesIspCat.packagesIspCatPackagesIspTemplates.length;
                      g++
                    ) {
                      for (let h=0;h<packagesIspCats[f].packagesIspCat.packagesIspCatPackagesIspTemplates[g].packagesIspTemplates.length;h++){
                        if (
                        packagesIspCats[f].packagesIspCat.packagesIspCatPackagesIspTemplates[g].packagesIspTemplates[h].isActive &&
                        !packagesIspCats[f].packagesIspCat.packagesIspCatPackagesIspTemplates[g].packagesIspTemplates[h].isDeleted
                      ) {
                        await allIspPackageTemplates.push(
                          packagesIspCats[f].packagesIspCat.packagesIspCatPackagesIspTemplates[g].packagesIspTemplates[h]
                        );
                      }
                      }
                    }
                  }
                }}
              });
          }

          Api()
            .put("/packagesIspCats/" + this.packagesIspCatObj.id, {
              customerId: this.packagesIspCatObj.customerId,
              name: this.packagesIspCatObj.name,
              code: this.packagesIspCatObj.code,
              description: this.packagesIspCatObj.description,
              packageCatType: this.packagesIspCatObj.packageCatType,
              isActive: true,
              isDeleted: false
            })
            .then(response => {
              this.editPackageGroup = false;
              this.$emit("groupTemplateChange");
            });
        }
        this.$emit("packagesIspsSaved");
        this.initialize();
      }
      }
    },

    createPackageFromTemplate() {
      let speedProfileId = this.editedItem.packagesIspTemplate.speedProfileId;
      let fnoPackages = this.locationPackages.filter(function(el) {
        return el.speedProfileId === speedProfileId;
      });
      for (let i = 0; i < fnoPackages.length; i++) {
        Api().post("/packagesIsps", {
          name: this.editedItem.packagesIspTemplate.name,
          description: this.editedItem.packagesIspTemplate.description,
          onceOffPriceVatInc: this.editedItem.packagesIspTemplate.onceOffPrice,
          recurringPriceVatInc: this.editedItem.packagesIspTemplate
            .recurringPrice,
          isPromotion: this.editedItem.packagesIspTemplate.isPromo,
          promotionDescription: this.editedItem.packagesIspTemplate
            .promoDescription,
          term: this.editedItem.packagesIspTemplate.term,
          isCapped: this.editedItem.packagesIspTemplate.isCapped,
          isShaped: this.editedItem.packagesIspTemplate.isShaped,
          layer3Contention: fnoPackages[i].speedProfile.contentionRatio,
          cappedAmountGb: this.editedItem.packagesIspTemplate.cappedAmountGb,
          isFup: this.editedItem.packagesIspTemplate.isFup,
          fupUrl: this.editedItem.packagesIspTemplate.fupUrl,
          startDate: new Date(),
          endDate: null,
          packagesFnoId: fnoPackages[i].id,
          locationNetworkId: this.editedItem.locationNetworkId,
          customerId: this.editedItem.packagesIspTemplate.customerId,
          isVerified: false,
          isRegistered: true,
          createdById: this.$store.state.user.id,
          lastModifiedById: this.$store.state.user.id,
          verifiedById: null,
          packagesIspTemplateId: this.editedItem.packagesIspTemplate.id,
          customerOrganisationId: this.$store.state.currentOrg.org.id,
          isActive: this.editedItem.isActive
        });
      }
      this.$emit("packagesIspsSaved");
      this.initialize();
      this.close();
    },
    registerPackageFromTemplate() {
      Api()
        .put("/packagesIsps/" + this.editedItem.id, {
          name: this.editedItem.packagesIspTemplate.name,
          description: this.editedItem.packagesIspTemplate.description,
          onceOffPriceVatInc: this.editedItem.packagesIspTemplate.onceOffPrice,
          recurringPriceVatInc: this.editedItem.packagesIspTemplate
            .recurringPrice,
          isPromotion: this.editedItem.packagesIspTemplate.isPromo,
          promotionDescription: this.editedItem.packagesIspTemplate
            .promoDescription,
          term: this.editedItem.packagesIspTemplate.term,
          isCapped: this.editedItem.packagesIspTemplate.isCapped,
          isShaped: this.editedItem.packagesIspTemplate.isShaped,
          layer3Contention: this.editedItem.layer3Contention,
          cappedAmountGb: this.editedItem.packagesIspTemplate.cappedAmountGb,
          isFup: this.editedItem.packagesIspTemplate.isFup,
          fupUrl: this.editedItem.packagesIspTemplate.fupUrl,
          startDate: new Date(),
          endDate: null,
          packagesFnoId: this.packagesFnoById.id,
          locationNetworkId: this.editedItem.locationNetworkId,
          customerId: this.editedItem.packagesIspTemplate.customerId,
          isVerified: false,
          isRegistered: true,
          createdById: this.editedItem.createdById,
          lastModifiedById: this.$store.state.user.id,
          verifiedById: null,
          packagesIspTemplateId: this.editedItem.packagesIspTemplate.id,
          isActive: this.editedItem.isActive
        })
        .then(response => {
          this.$emit("packagesIspsSaved");
          this.initialize();
        });
      this.close();
      this.registerDialog = false;
      this.pricingTerm = false;
    },
    save() {
      let proceed = true;
      if (this.editedItem.name == "") {
        proceed = false;
        confirm("Please fill in a name.");
      }
      if (this.editedItem.locationNetworkId == "") {
        proceed = false;
        confirm("Please select a location network.");
      }
      if (this.editedItem.packagesFnoId == "") {
        proceed = false;
        confirm("Please select a fno package.");
      }
      if (this.editedItem.term == "") {
        proceed = false;
        confirm("Please select a contract term.");
      }
      if (this.editedItem.startDate == "") {
        proceed = false;
        confirm("Please select a start date.");
      }
      if (
        this.editedItem.onceOffPriceVatInc == "" &&
        !this.editedItem.onceOffPriceVatInc == 0
      ) {
        proceed = false;
        confirm(
          "Please enter the total once off costs to the end Client(incl. VAT)"
        );
      }
      if (
        this.editedItem.recurringPriceVatInc == "" &&
        !this.editedItem.recurringPriceVatInc == 0
      ) {
        proceed = false;
        confirm(
          "Please enter the total monthly price to the end Client (incl. VAT)"
        );
      }
      if (proceed == true) {
        if (this.editedItem.attachPackageToTemplate) {
          Api()
            .put("/packagesIsps/" + this.editedItem.id, {
              name: this.editedItem.packagesIspTemplate.name,
              description: this.editedItem.packagesIspTemplate.description,
              onceOffPriceVatInc: this.editedItem.packagesIspTemplate
                .onceOffPrice,
              recurringPriceVatInc: this.editedItem.packagesIspTemplate
                .recurringPrice,
              isPromotion: this.editedItem.packagesIspTemplate.isPromo,
              promotionDescription: this.editedItem.packagesIspTemplate
                .promoDescription,
              term: this.editedItem.packagesIspTemplate.term,
              isCapped: this.editedItem.packagesIspTemplate.isCapped,
              isShaped: this.editedItem.packagesIspTemplate.isShaped,
              layer3Contention: this.editedItem.packagesIspTemplate
                .layer3Contention,
              cappedAmountGb: this.editedItem.packagesIspTemplate
                .cappedAmountGb,
              isFup: this.editedItem.packagesIspTemplate.isFup,
              startDate: this.editedItem.startDate,
              endDate: this.editedItem.endDate,
              packagesFnoId: this.packagesFnoById.id,
              locationNetworkId: this.editedItem.locationNetworkId,
              customerId: this.editedItem.packagesIspTemplate.customerId,
              isVerified: this.editedItem.isVerified,
              createdById: this.editedItem.createdById,
              lastModifiedById: this.$store.state.user.id,
              verifiedById: this.editedItem.verifiedById,
              packagesIspTemplateId: this.editedItem.packagesIspTemplate.id,
              isActive: this.editedItem.isActive
            })
            .then(response => {
              this.$emit("packagesIspsSaved");
              this.initialize();
            });
        } else {
          Api()
            .put("/packagesIsps/" + this.editedItem.id, {
              name: this.editedItem.name,
              description: this.editedItem.description,
              onceOffPriceVatInc: this.editedItem.onceOffPriceVatInc,
              recurringPriceVatInc: this.editedItem.recurringPriceVatInc,
              isPromotion: this.editedItem.isPromotion,
              promotionDescription: this.editedItem.promotionDescription,
              term: this.editedItem.term,
              isCapped: this.editedItem.isCapped,
              isShaped: this.editedItem.isShaped,
              layer3Contention: this.editedItem.layer3Contention,
              cappedAmountGb: this.editedItem.cappedAmountGb,
              isFup: this.editedItem.isFup,
              fupUrl: this.editedItem.fupUrl,
              startDate: this.editedItem.startDate,
              endDate: this.editedItem.endDate,
              packagesFnoId: this.packagesFnoById.id,
              locationNetworkId: this.editedItem.locationNetworkId,
              customerId: this.editedItem.customerId,
              isVerified: this.editedItem.isVerified,
              createdById: this.editedItem.createdById,
              lastModifiedById: this.$store.state.user.id,
              verifiedById: this.editedItem.verifiedById,
              packagesIspTemplateId: null,
              isActive: this.editedItem.isActive
            })
            .then(response => {
              this.$emit("packagesIspsSaved");
              this.initialize();
            });
        }

        this.close();
      }
    },
    saveNew() {
      let proceed = true;
      if (this.editedItem.name == "") {
        proceed = false;
        confirm("Please fill in a name.");
      }
      if (this.editedItem.locationNetworkId == "") {
        proceed = false;
        confirm("Please select a location network.");
      }
      if (this.editedItem.packagesFnoId == "") {
        proceed = false;
        confirm("Please select a fno package.");
      }
      if (this.editedItem.term == "") {
        proceed = false;
        confirm("Please select a contract term.");
      }
      if (this.editedItem.startDate == "") {
        proceed = false;
        confirm("Please select a start date.");
      }
      if (this.editedItem.onceOffPriceVatInc == "") {
        proceed = false;
        confirm(
          "Please enter the total once off costs to the end Client(incl. VAT)"
        );
      }
      if (this.editedItem.recurringPriceVatInc == "") {
        proceed = false;
        confirm(
          "Please enter the total monthly price to the end Client (incl. VAT)"
        );
      }
      if (proceed == true) {
        if (this.editedItem.description != true) {
          this.editedItem.description = null;
        }
        if (this.editedItem.isPromotion != true) {
          this.editedItem.isPromotion = false;
          this.editedItem.endDate = null;
        }
        if (this.editedItem.isCapped != true) {
          this.editedItem.isCapped = false;
          this.editedItem.cappedAmountGb = null;
        }
        if (this.editedItem.isFup != true) {
          this.editedItem.isFup = false;
        }
        Api()
          .get("/packagesIsps/" + this.editedItem.packagesFnoId)
          .then(response => {
            if (
              typeof response.data[0] !== "undefined" ||
              response.data[0] == ""
            ) {
              this.editedItem.packagesFnoId = response.data[0].packagesFno.id;
            }
            Api()
              .post("/packagesIsps", {
                name: this.editedItem.name,
                description: this.editedItem.description,
                onceOffPriceVatInc: this.editedItem.onceOffPriceVatInc,
                recurringPriceVatInc: this.editedItem.recurringPriceVatInc,
                isPromotion: this.editedItem.isPromotion,
                term: this.editedItem.term,
                isCapped: this.editedItem.isCapped,
                cappedAmountGb: this.editedItem.cappedAmountGb,
                layer3Contention: this.editedItem.layer3Contention,
                isShaped: this.editedItem.isShaped,
                isFup: this.editedItem.isFup,
                fupUrl: this.editedItem.fupUrl,
                startDate: this.editedItem.startDate,
                endDate: this.editedItem.endDate,
                packagesFnoId: this.packagesFnoById.id,
                locationNetworkId: this.editedItem.locationNetworkId,
                customerId: this.editedItem.customerId,
                isRegistered: true,
                isVerified: false,
                createdById: this.$store.state.user.id,
                lastModifiedById: this.$store.state.user.id
              })
              .then(response => {
                this.$emit("packagesIspsSaved");
                this.initialize();
              });
            this.close();
            this.newDialog = false;
            this.packageSummary = false;
          });
      }
    },
    registerNew() {
      let proceed = true;
      if (this.editedItem.name == "") {
        proceed = false;
        confirm("Please fill in a name.");
      }
      if (this.editedItem.customerId == "") {
        proceed = false;
        confirm("Please select an internet service provider.");
      }
      if (this.editedItem.packagesFnoId == "") {
        proceed = false;
        confirm("Please select a fno package.");
      }
      if (this.editedItem.term == "") {
        proceed = false;
        confirm("Please select a contract term.");
      }
      if (this.editedItem.startDate == "") {
        proceed = false;
        confirm("Please select a start date.");
      }
      if (
        this.editedItem.onceOffPriceVatInc == "" &&
        !this.editedItem.onceOffPriceVatInc == 0
      ) {
        proceed = false;
        confirm(
          "Please enter the total once off costs to the end Client(incl. VAT)"
        );
      }
      if (
        this.editedItem.recurringPriceVatInc == "" &&
        !this.editedItem.recurringPriceVatInc == 0
      ) {
        proceed = false;
        confirm(
          "Please enter the total monthly price to the end Client (incl. VAT)"
        );
      }
      if (proceed == true) {
        Api()
          .put("/packagesIsps/" + this.editedItem.id, {
            name: this.editedItem.name,
            description: this.editedItem.description,
            onceOffPriceVatInc: this.editedItem.onceOffPriceVatInc,
            recurringPriceVatInc: this.editedItem.recurringPriceVatInc,
            isPromotion: this.editedItem.isPromotion,
            term: this.editedItem.term,
            isCapped: this.editedItem.isCapped,
            cappedAmountGb: this.editedItem.cappedAmountGb,
            layer3Contention: this.editedItem.layer3Contention,
            isFup: this.editedItem.isFup,
            fupUrl: this.editedItem.fupUrl,
            isShaped: this.editedItem.isShaped,
            startDate: this.editedItem.startDate,
            endDate: this.editedItem.endDate,
            packagesFnoId: this.packagesFnoById.id,
            customerId: this.editedItem.customerId,
            isRegistered: true,
            isVerified: false,
            lastModifiedById: this.$store.state.user.id,
            isActive: true,
            isDeleted: false
          })
          .then(response => {
            this.$emit("packagesIspsSaved");
            this.initialize();
          });
        this.close();
        this.registerDialog = false;
        this.packageSummary = false;
      }
    }
  }
};
</script>
<style scoped>
.truncate {
      max-width: 20px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
</style>


